import type { TypePolicy } from '@apollo/client/cache/inmemory/policies';

export const ActivityChallenge: TypePolicy = {
    keyFields: ['name'],
};
